import { Divider } from "@mui/material";

import type { RootState } from "../store/state/rootReducer";

import { makeStyles } from "./theme/theme";
import { DrawerMenuItemRow } from "./NewDrawerMenu";

const useClasses = makeStyles()((theme) => ({
  subMenu: {
    [theme.breakpoints.down("sm")]: {
      paddingLeft: theme.spacing(1),
    },
  },
}));

export interface IDrawerMenuSubItemProps {
  ids: readonly string[];
  idMap: RootState["frame"]["nav"]["itemsById"];
  setIsExpanded: (expanded: boolean) => void;
}

export function DrawerMenuSubItem({ ids, idMap, setIsExpanded }: IDrawerMenuSubItemProps) {
  const { classes } = useClasses();

  return (
    <div className={classes.subMenu}>
      {ids
        .map((childId) => idMap[childId])
        .map((childRoute, idx) => (
          <>
            {childRoute.divided ? (
              idx > 0 ? (
                <Divider />
              ) : null
            ) : (
              <DrawerMenuItemRow route={childRoute} setIsExpanded={setIsExpanded} />
            )}
            {childRoute.children.length > 0 ? (
              <DrawerMenuSubItem ids={childRoute.children} idMap={idMap} setIsExpanded={setIsExpanded} />
            ) : null}
          </>
        ))}
    </div>
  );
}
